/* eslint-disable */
import {
  Flex,
  Table,
  Tbody,
  Td,
  Text,
  Thead,
  Tr,
  useColorModeValue,
  Button,
  TableCaption,
  Center,
  Stack,
  Modal,
  ModalOverlay,
  ModalHeader,
  ModalBody,
  ModalContent,
  ModalFooter,
  FormControl,
  FormLabel,
  Input,
  Select,
  useToast,
  Grid,
  GridItem,
  Box,
  Spinner,
  Image,
  Badge,
  Textarea,
  Checkbox,
} from "@chakra-ui/react";
// Custom components
import { SingleDatepicker } from "chakra-dayzed-datepicker";
import Card from "components/card/Card";
import { HSeparator } from "components/separator/Separator";
import { CheckIcon, InfoIcon, QuestionIcon, DownloadIcon, ArrowBackIcon, ArrowForwardIcon } from '@chakra-ui/icons';
import React, { useEffect, useState } from "react";
import { convertDate, URL_WEB_BACKEND, decryptData } from "CustomUtil";
import axios from "axios";
import { utils as xlxUtils, writeFile as xlxWriteFile, write as xlxWrite } from "xlsx";
import { saveAs } from "file-saver";
import { URL_WEB_FORNTEND } from "CustomUtil";

export default function SumasTable({ refreshing }) {
  const authdata = decryptData(localStorage.getItem("authinfosemakinpas"));
  const cekadmin = decryptData(localStorage.getItem("authrolesemakinpas"));
  const userid = decryptData(localStorage.getItem("authidsemakinpas"));

  const [sumas, setSumas] = useState([]);
  const [idSelectedData, setIdSelectedData] = useState(0);
  const [titleDialog, setTitleDialog] = useState('title');
  const [descDialog, setDescDialog] = useState('desc');
  const [statusInfoDialog, setStatusInfoDialog] = useState(false);
  const [infoDialogIcon, setInfoDialogIcon] = useState(1);
  const [statusConfExeDialog, setStatusConfExeDialog] = useState(false);
  const [actionConfExeDialog, setActionConfExeDialog] = useState(1);
  const [statusEditDialog, setStatusEditDialog] = useState(false);
  const [statusEditDispoDialog, setStatusEditDispoDialog] = useState(false);
  const [statusUploading, setStatusUploading] = useState(false);
  const [statusLoading, setStatusLoading] = useState(false);
  const toast = useToast();

  // add
  const [isisurat, setIsisurat] = useState('');
  const [lampiran, setLampiran] = useState(0);
  const [tanggalsurat, setTanggalsurat] = useState(new Date());
  const [dari, setDari] = useState('');
  const [pengoleh, setPengoleh] = useState('');
  const [tanggalBuatNomor, setTanggalBuatNomor] = useState(new Date());
  const [filesurat, setFilesurat] = useState(null);
  const [idPembuatSurat, setIdPembuatSurat] = useState(0);
  const [verifIdSurat, setVerifIdSurat] = useState('');
  const [nosurat, setNosurat] = useState('');
  const [isidisposisi, setIsidisposisi] = useState('');
  const [disposisiKe, setDisposisiKe] = useState([]);

  // pagination
  const [isPagination, setIsPagination] = useState(true);
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [allPageNumber, setAllPageNumber] = useState(0);

  // disposisi
  const opsiDisposisi = ['Kabag Tata Usaha', 'Ka KPLP', 'Kabid Adm Kamtib', 'Kabid Pembinaan', 'Kabid Giatja'];

  const handleCheckboxDisposisiChange = (value) => {
    if (disposisiKe.includes(value)) {
      setDisposisiKe(disposisiKe.filter(item => item !== value));
    } else {
      setDisposisiKe([...disposisiKe, value]);
    }
  };

  // search
  const [searchClue, setSearchClue] = useState('');
  const [searchCat, setSearchCat] = useState('isisurat');

  const catOpt = [
    { value: 'isisurat', label: 'Isi Ringkas' },
    { value: 'nosurat', label: 'Nomor Surat' },
    { value: 'dari', label: 'Asal Surat' },
    { value: 'disposisike', label: 'Tujuan Disposisi' },
    { value: 'isidisposisi', label: 'Isi Disposisi' },
    { value: 'pengoleh', label: 'Pengoleh' },
  ];

  // Chakra Color Mode
  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const textColorSecondary = "gray.400";

  const textColor = useColorModeValue("secondaryGray.900", "white");

  useEffect(() => {
    if (refreshing || sumas.length < 1 || sumas === undefined) {
      getSumas(1);
    }
  }, [refreshing]);

  useEffect(() => {
    getSumas(1);
  }, [searchClue]);

  const getSumas = async (pagesNumber) => {
    setStatusLoading(true);
    setSumas([]);
    if (searchClue === '') {
      setIsPagination(true);
      await axios.get(URL_WEB_BACKEND + '/sumas?page=' + pagesNumber, {
        headers: {
          'Authorization': 'Bearer ' + authdata
        }
      }).then((response) => {
        setSumas(response.data.sumas);
        setAllPageNumber(response.data.pages);
        setStatusLoading(false);
      }).catch(err => {
        setStatusLoading(false);
        toast({
          status: 'error',
          title: 'Error status ' + err.response.status,
          description: 'Data kosong.',
          position: 'bottom-right',
          isClosable: true,
        })
      });
    } else {
      setIsPagination(false);
      await axios.get(URL_WEB_BACKEND + '/cari/sumas/' + searchCat + '/' + searchClue + '?page=' + pagesNumber, {
        headers: {
          'Authorization': 'Bearer ' + authdata
        }
      }).then((response) => {
        setIsPagination(true);
        setSumas(response.data.sumas);
        setAllPageNumber(response.data.pages);
        setStatusLoading(false);
      }).catch(err => {
        setStatusLoading(false);
        toast({
          status: 'error',
          title: 'Error status ' + err.response.status,
          description: 'Tak ada data yang dicari.',
          position: 'bottom-right',
          isClosable: true,
        })
      });
    }
  }

  const exeEdit = async () => {
    setStatusUploading(true); setStatusEditDialog(false); setStatusConfExeDialog(false);
    const formDataEdit = new FormData();
    formDataEdit.append('tanggal', new Date(tanggalBuatNomor.getTime() - tanggalBuatNomor.getTimezoneOffset() * 60 * 1000).toJSON().slice(0, 19).replace('T', ' '))
    formDataEdit.append('nosurat', nosurat.toUpperCase().replace(/\s+/g, ""))
    formDataEdit.append('tanggalsurat', new Date(tanggalsurat.getTime() - tanggalsurat.getTimezoneOffset() * 60 * 1000).toJSON().slice(0, 19).replace('T', ' '))
    formDataEdit.append('isisurat', isisurat)
    formDataEdit.append('lampiran', lampiran)
    formDataEdit.append('dari', dari)
    formDataEdit.append('id_user', idPembuatSurat)
    formDataEdit.append('pengoleh', pengoleh)
    formDataEdit.append('verifid', verifIdSurat)
    if (filesurat != null) {
      formDataEdit.append('filesurat', filesurat)
    }
    await axios.post(URL_WEB_BACKEND + '/updatesumas/' + idSelectedData, formDataEdit, {
      headers: {
        'Authorization': 'Bearer ' + authdata,
        'content-type': 'application/ x-www-form-urlencoded'
      }
    }).then(res => {
      if (res.status === 200) {
        getSumas(currentPageNumber); setStatusUploading(false);
        showInfoDialog('Berhasil', 'Data berhasil diperbarui', 0);
      } else {
        setStatusUploading(false);
        let reskey = Object.keys(res.response.data.messages)[0];
        showInfoDialog('Error Perbarui Surat masuk dengan status ' + res.response.status, res.response.messages[reskey], 1)
      }
    }).catch(err => {
      setStatusUploading(false);
      let errkey = Object.keys(err.response.data.messages)[0];
      showInfoDialog('Error Perbarui Surat masuk dengan status ' + err.response.status, err.response.data.messages[errkey], 1)
    })
  }

  const exeEditDispo = async () => {
    setStatusUploading(true); setStatusEditDispoDialog(false); setStatusConfExeDialog(false);
    const dataUntukSimpan = disposisiKe.filter(item => item.trim() !== '').join(',');
    const formDataEditDispo = new FormData();
    formDataEditDispo.append('isidisposisi', isidisposisi)
    formDataEditDispo.append('disposisike', dataUntukSimpan)
    await axios.post(URL_WEB_BACKEND + '/updatedisposumas/' + idSelectedData, formDataEditDispo, {
      headers: {
        'Authorization': 'Bearer ' + authdata,
        'content-type': 'application/ x-www-form-urlencoded'
      }
    }).then(res => {
      if (res.status === 200) {
        getSumas(currentPageNumber); setStatusUploading(false);
        showInfoDialog('Berhasil', 'Disposisi Tersimpan', 0);
      } else {
        setStatusUploading(false);
        let reskey = Object.keys(res.response.data.messages)[0];
        showInfoDialog('Error Perbarui Surat masuk dengan status ' + res.response.status, res.response.messages[reskey], 1)
      }
    }).catch(err => {
      setStatusUploading(false);
      let errkey = Object.keys(err.response.data.messages)[0];
      showInfoDialog('Error Perbarui Surat masuk dengan status ' + err.response.status, err.response.data.messages[errkey], 1)
    })
  }

  const exeDelete = async () => {
    setStatusConfExeDialog(false);
    await axios.delete(URL_WEB_BACKEND + '/sumas/' + idSelectedData, {
      headers: {
        'Authorization': 'Bearer ' + authdata
      }
    }).then(res => {
      if (res.status === 200) {
        getSumas(currentPageNumber);
        showInfoDialog('Berhasil', 'Data Berhasil Dihapus', 0)
      } else {
        let reskey = Object.keys(res.response.data.messages)[0];
        showInfoDialog('Error Hapus dengan status ' + res.response.status, res.response.messages[reskey], 1)
      }
    }).catch(err => {
      let errkey = Object.keys(err.response.data.messages)[0];
      showInfoDialog('Error Hapus dengan status ' + err.response.status, err.response.data.messages[errkey], 1)
    })
  }

  const downloadToExcel = async () => {
    await axios.get(URL_WEB_BACKEND + '/getallsumas', {
      headers: {
        'Authorization': 'Bearer ' + authdata
      }
    }).then((response) => {
      const worksheet = xlxUtils.json_to_sheet(response.data);
      const workbook = xlxUtils.book_new();
      xlxUtils.book_append_sheet(workbook, worksheet, "Sheet1");
      // let buffer = xlxWrite(workbook, { bookType: "xlsx", type: "buffer" });
      // xlxWrite(workbook, { bookType: "xlsx", type: "binary" });
      xlxWriteFile(workbook, "Disposisi_Surat_Masuk_LPP_Yogyakarta_Pertanggal_" + new Date().toISOString().slice(0, 10) + ".xlsx");
    }).catch(err => {
      toast({
        status: 'error',
        title: 'Error status ' + err.response.status,
        description: 'Data Semua Surat Keluar kosong.',
        position: 'bottom-right',
        isClosable: true,
      })
    });
  };

  function showInfoDialog(title, desc, infoicon) {
    setTitleDialog(title); setDescDialog(desc); setInfoDialogIcon(infoicon); setStatusInfoDialog(true);
  }

  function showConfExeDialog(title, desc, action) {
    setTitleDialog(title); setDescDialog(desc); setStatusConfExeDialog(true); setActionConfExeDialog(action);
  }

  function showEditDialog(title, desc) {
    setTitleDialog(title); setDescDialog(desc); setStatusEditDialog(true);
  }

  function showEditDispoDialog(title, desc) {
    setTitleDialog(title); setDescDialog(desc); setStatusEditDispoDialog(true);
  }

  const viewInfoDialog = () => {
    return (
      <Modal closeOnOverlayClick={true} isCentered isOpen={statusInfoDialog}>
        <ModalOverlay
          bg='blackAlpha.300'
          backdropFilter='blur(10px) hue-rotate(10deg)'
        />
        <ModalContent>
          <ModalHeader>{titleDialog}</ModalHeader>
          <ModalBody>
            <Center>
              {infoDialogIcon
                ? <InfoIcon w={16} h={16} color="blue.500" />
                : <CheckIcon w={16} h={16} color="green.500" />
              }
            </Center>
            <Center mt={8}>
              <Text fontSize='large'>{descDialog}</Text>
            </Center>
          </ModalBody>
          <ModalFooter>
            <Button onClick={() => { setStatusInfoDialog(false) }}>OK</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    )
  }

  const viewConfExeDialog = () => {
    return (
      <Modal closeOnOverlayClick={true} isCentered isOpen={statusConfExeDialog}>
        <ModalOverlay
          bg='blackAlpha.300'
          backdropFilter='blur(10px) hue-rotate(10deg)'
        />
        <ModalContent>
          <ModalHeader>{titleDialog}</ModalHeader>
          <ModalBody>
            <Center><QuestionIcon w={16} h={16} color="blue.500" /></Center>
            <Center mt={8}>
              <Text fontSize='large'>{descDialog}</Text>
            </Center>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme='red' mr={3} onClick={() => {
              {
                if (actionConfExeDialog === 1) {
                  exeEdit();
                } else if (actionConfExeDialog === 2) {
                  exeEditDispo();
                } else {
                  exeDelete();
                }
              }
            }}>
              Iya, Lanjutkan
            </Button>
            <Button onClick={() => { setStatusConfExeDialog(false) }}>Batal</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    )
  }

  const viewEditDialog = () => {
    return (
      <Modal closeOnOverlayClick={true} isCentered isOpen={statusEditDialog}>
        <ModalOverlay
          bg='blackAlpha.300'
          backdropFilter='blur(10px) hue-rotate(10deg)'
        />
        <ModalContent>
          <ModalHeader>
            <Text
              color={textColorPrimary}
              fontWeight='bold'
              textAlign='start'
              fontSize='2xl'
              mt={{ base: "5px", "2xl": "5px" }}>
              {titleDialog}
            </Text>
            <Text
              color={textColorSecondary}
              fontSize='md'
              my={{ base: "auto", "2xl": "10px" }}
              textAlign='start'>
              {descDialog}
            </Text>
          </ModalHeader>
          <ModalBody>
            <FormControl id={"editsuma" + idSelectedData} isRequired>
              <FormControl>
                <FormLabel>Nomor Surat</FormLabel>
                <Input variant='filled' id={"add" + idSelectedData + 8} borderRadius="16px" value={nosurat} onChange={(e) => setNosurat(e.target.value)} />
              </FormControl>
              <FormLabel>Isi Ringkas</FormLabel>
              <Input id={"add" + idSelectedData + 1} placeholder="Masukkan isi surat secara ringkas" borderRadius="16px" value={isisurat} onChange={(e) => setIsisurat(e.target.value)} />
              <FormLabel>Lampiran</FormLabel>
              <Input type='number' id={"add" + idSelectedData + 2} placeholder="Masukkan jumlah lampiran" borderRadius="16px" value={lampiran} onChange={(e) => setLampiran(e.target.value)} />
              <FormLabel>Tanggal Surat</FormLabel>
              <SingleDatepicker
                name="date-input-tglsurat"
                date={tanggalsurat}
                onDateChange={setTanggalsurat}
              />
              <FormLabel>Tanggal Input</FormLabel>
              <SingleDatepicker
                name="date-input-tgl"
                date={tanggalBuatNomor}
                onDateChange={setTanggalBuatNomor}
              />
              <FormLabel>Asal Surat & Media Pengiriman</FormLabel>
              <Input id={"add" + idSelectedData + 3} placeholder="Masukkan asal surat" borderRadius="16px" value={dari} onChange={(e) => setDari(e.target.value)} />
              <FormLabel>Pengoleh</FormLabel>
              <Input id={"add" + idSelectedData + 7} placeholder="Masukkan nama pengoleh" borderRadius="16px" value={pengoleh} onChange={(e) => setPengoleh(e.target.value)} />
              <FormControl id={"add" + idSelectedData + 2}>
                <FormLabel>Ganti File Surat (Opsional)</FormLabel>
                <Input variant='main' h='100' mb='5' border='2px dashed' type='file' id={"uploadfile" + idSelectedData + 5} placeholder="Pilih file surat" borderRadius="16px" onChange={(e) => setFilesurat(e.target.files[0])} />
              </FormControl>
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme='blue' mr={3} onClick={() => {
              {
                if (nosurat === '' || isisurat === '' || lampiran === '' || dari === '' || pengoleh === '') {
                  toast({
                    status: 'error',
                    title: 'Proses Gagal',
                    description: 'Masih ada kolom yang kosong',
                    position: 'bottom-right',
                    isClosable: true,
                  })
                } else { showConfExeDialog('Edit Data Surat Masuk', 'Simpan pembaruan surat masuk ini?', 1) }
              }
            }}>
              Simpan
            </Button>
            <Button onClick={() => {
              setStatusEditDialog(false); setIsisurat(''); setLampiran(0); setTanggalsurat(new Date()); setDari('');
              setPengoleh('');
            }}>Batal</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    )
  }

  const viewEditDispoDialog = () => {
    return (
      <Modal closeOnOverlayClick={true} isCentered isOpen={statusEditDispoDialog}>
        <ModalOverlay
          bg='blackAlpha.300'
          backdropFilter='blur(10px) hue-rotate(10deg)'
        />
        <ModalContent>
          <ModalHeader>
            <Text
              color={textColorPrimary}
              fontWeight='bold'
              textAlign='start'
              fontSize='2xl'
              mt={{ base: "5px", "2xl": "5px" }}>
              {titleDialog}
            </Text>
            <Text
              color={textColorSecondary}
              fontSize='md'
              my={{ base: "auto", "2xl": "10px" }}
              textAlign='start'>
              {descDialog}
            </Text>
          </ModalHeader>
          <ModalBody>
            <Text><b>Isi Ringkas : {isisurat}</b></Text>
            <FormControl id={"editdisposuma" + idSelectedData} isRequired>
              <FormLabel mt={4}>Isi Disposisi</FormLabel>
              <Textarea id={"editt" + idSelectedData + 1} placeholder="Masukkan isi disposisi" borderRadius="16px" value={isidisposisi} onChange={(e) => setIsidisposisi(e.target.value)} />
              <FormLabel mt={4}>Disposisi Kepada</FormLabel>
              <Stack spacing={2}>
                {opsiDisposisi.map((item) => (
                  <Checkbox
                    key={item}
                    isChecked={disposisiKe.includes(item)}
                    onChange={() => handleCheckboxDisposisiChange(item)}
                  >
                    {item}
                  </Checkbox>
                ))}
              </Stack>
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme='blue' mr={3} onClick={() => {
              {
                if (nosurat === '' || isisurat === '' || lampiran === '' || dari === '' || pengoleh === '') {
                  toast({
                    status: 'error',
                    title: 'Proses Gagal',
                    description: 'Masih ada kolom yang kosong',
                    position: 'bottom-right',
                    isClosable: true,
                  })
                } else { showConfExeDialog('Edit Data Disposisi', 'Simpan disposisi untuk surat masuk ini?', 2) }
              }
            }}>
              Simpan
            </Button>
            <Button onClick={() => { setStatusEditDispoDialog(false); setIsisurat(''); setLampiran(0); setTanggalsurat(new Date()); setDari(''); setPengoleh(''); }}>Batal</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    )
  }

  const viewUploadingDialog = () => {
    return (
      <Modal closeOnOverlayClick={false} isCentered isOpen={statusUploading}>
        <ModalOverlay
          bg='blackAlpha.300'
          backdropFilter='blur(10px) hue-rotate(10deg)'
        />
        <ModalContent>
          <Center pb={5} pt={5}>
            <Spinner
              thickness='4px'
              speed='0.95s'
              emptyColor='gray.200'
              color='blue.500'
              size='xl'
            />
          </Center>
          <Center pb={5} pt={5}>
            <Text>Mengunggah...</Text>
          </Center>
        </ModalContent>
      </Modal>
    )
  }

  return (
    <Card
      direction='column'
      w='100%'
      px='0px'
      overflowX={{ sm: "scroll", lg: "hidden" }}>
      <Flex px='25px' justify='space-between' mb='20px' align='center'>
        {viewInfoDialog()}{viewConfExeDialog()}{viewEditDialog()}{viewEditDispoDialog()}{viewUploadingDialog()}
        <Text
          color={textColor}
          fontSize='22px'
          fontWeight='700'
          lineHeight='100%'>
          Daftar Surat Masuk
        </Text>
        <Flex justify='space-between' align='end'>
          <Button
            variant='action'
            onClick={() => downloadToExcel()}>
            <Text
              fontSize='lg'
              as='b'>
              Ekspor Semua Data ke Excel
            </Text>
          </Button>
        </Flex>
      </Flex>
      <Table minH='600' variant='unstyled'>
        <TableCaption>
          {isPagination && allPageNumber >= 1 ?
            <Grid templateColumns="repeat(3, 1fr)" gap={2}>
              {currentPageNumber === 1 ? <Button disabled><ArrowBackIcon me='2' />Sebelum</Button> : <Button onClick={() => { setCurrentPageNumber(currentPageNumber - 1); setTimeout(() => getSumas(currentPageNumber - 1), 1000); }}><ArrowBackIcon me='2' />Sebelum</Button>}
              <Button>{currentPageNumber}</Button>
              {currentPageNumber === allPageNumber ? <Button disabled>Lanjut<ArrowForwardIcon ms='2' /></Button> : <Button onClick={() => { setCurrentPageNumber(currentPageNumber + 1); setTimeout(() => getSumas(currentPageNumber + 1), 1000); }}>Lanjut<ArrowForwardIcon ms='2' /></Button>}
            </Grid>
            : <Text as='b'>akhir dari tabel.</Text>
          }
        </TableCaption>
        <Thead><Tr>
          <Td>
            <Grid templateColumns="repeat(5, 1fr)" gap={2}>
              <Select borderRadius='16px' aria-label="Default" value={searchCat} onChange={(e) => setSearchCat(e.target.value)}>
                {catOpt.map((option) => (<option key={option.value} value={option.value}>{option.label}</option>))}
              </Select>
              <GridItem colSpan='4'>
                <Input variant='filled' id={"search" + searchClue} placeholder="Cari Surat Masuk" borderRadius="16px" value={searchClue} onChange={(e) => setSearchClue(e.target.value)} />
              </GridItem>
            </Grid>
          </Td>
        </Tr></Thead>
        <Tbody>
          {sumas.length < 1
            ? <Tr><Td><Center mb={6}>{statusLoading ? <Spinner thickness='4px' speed='0.95s' emptyColor='gray.200' color='blue.500' size='xl' /> : <>Belum ada surat masuk.</>}</Center></Td></Tr>
            : <>
              {sumas.map((datasumas, index) => (
                <Tr key={index} >
                  <Td>
                    <Card direction="row" p='6' boxShadow="md" m='2' borderRadius="lg">
                      {datasumas.isidisposisi !== '' || datasumas.disposisike !== '' ? <Badge colorScheme="green" width='30%' marginBottom={5}>SUDAH DISPOSISI</Badge> : <Badge colorScheme="red" width='30%' marginBottom={5}>BELUM DISPOSISI</Badge>}
                      <Grid templateColumns="repeat(2, 1fr)" gap={8}>
                        <Box w='100%'>
                          <Text as='b'>ISI RINGKAS</Text><HSeparator mb='1' />{datasumas.isisurat}<br /><br />
                          <Text as='b'>NOMOR SURAT</Text><HSeparator mb='1' />{datasumas.nosurat}<br /><br />
                          <Grid templateColumns="repeat(2, 1fr)" gap={1}>
                            <Box w='100%'>
                              <Text as='b'>TANGGAL SURAT</Text><HSeparator mb='1' />{convertDate(datasumas.tanggalsurat)}<br /><br />
                            </Box>
                            <Box w='100%'>
                              <Text as='b'>LAMPIRAN</Text><HSeparator mb='1' />{datasumas.lampiran}<br /><br />
                            </Box>
                          </Grid>
                          <Grid templateColumns="repeat(2, 1fr)" gap={1}>
                            <Box w='100%'>
                              <Text as='b'>ASAL SURAT & MEDIA PENGIRIMAN</Text><HSeparator mb='1' />{datasumas.dari}<br /><br />
                            </Box>
                            <Box w='100%'>
                              <Text as='b'>TANGGAL INPUT</Text><HSeparator mb='1' />{convertDate(datasumas.tanggal)}<br /><br />
                            </Box>
                          </Grid>
                          <Text as='b'>FILE SURAT</Text><HSeparator mb='1' />{datasumas.extfile === 'null' ? (<>-</>) : (<Button onClick={() => saveAs(URL_WEB_BACKEND + "/uploads/sumas/file/" + datasumas.verifid + '_' + datasumas.id_user + '.' + datasumas.extfile, 'SUMA-' + datasumas.tanggal + '-' + datasumas.nosurat + '.' + datasumas.extfile)}><DownloadIcon /> LIHAT DISINI</Button>)}<br /><br />
                          <Stack direction={{ base: 'column', md: 'row' }}>
                            {cekadmin === 'admin' | cekadmin === 'um' | datasumas.id_user === userid ?
                              <Button colorScheme="green" onClick={() => {
                                setIdSelectedData(datasumas.id); setIsisurat(datasumas.isisurat); setNosurat(datasumas.nosurat); setTanggalsurat(new Date(datasumas.tanggalsurat + ' 01:00:00')); setLampiran(datasumas.lampiran); setDari(datasumas.dari); setTanggalBuatNomor(new Date(datasumas.tanggal + ' 01:00:00')); setIdPembuatSurat(parseInt(datasumas.id_user)); setPengoleh(datasumas.pengoleh); setVerifIdSurat(datasumas.verifid); setIsidisposisi(datasumas.isidisposisi); setDisposisiKe(datasumas.disposisike.split(','));
                                setTimeout(() => {
                                  showEditDispoDialog('Masukkan Disposisi', 'Perbarui disposisi sesuai arahan Kalapas.')
                                }, 200);
                              }}>DISPOSISI</Button>
                              : <></>}
                            {cekadmin === 'admin' || cekadmin === 'um' ?
                              <Button colorScheme="blue" onClick={() => {
                                setIdSelectedData(datasumas.id); setIsisurat(datasumas.isisurat); setNosurat(datasumas.nosurat); setTanggalsurat(new Date(datasumas.tanggalsurat + ' 01:00:00')); setLampiran(datasumas.lampiran); setDari(datasumas.dari); setTanggalBuatNomor(new Date(datasumas.tanggal + ' 01:00:00')); setIdPembuatSurat(parseInt(datasumas.id_user)); setPengoleh(datasumas.pengoleh); setVerifIdSurat(datasumas.verifid); setIsidisposisi(datasumas.isidisposisi); setDisposisiKe(datasumas.disposisike.split(','));
                                setTimeout(() => {
                                  showEditDialog('Edit Surat Masuk', 'Perbarui detail surat masuk agar sesuai.')
                                }, 200);
                              }}>EDIT</Button>
                              : <></>}
                            {cekadmin === 'admin' | cekadmin === 'um' | datasumas.id_user === userid ?
                              <Button variant="outline" colorScheme="red" onClick={() => {
                                setIdSelectedData(datasumas.id);
                                setTimeout(() => {
                                  showConfExeDialog('Hapus Surat Masuk', 'Pastikan data yang dihapus adalah data yang tidak digunakan! Yakin hapus surat ' + datasumas.isisurat + ' ?', 3)
                                }, 200);
                              }}>HAPUS</Button>
                              : <></>}
                            <Button
                              leftIcon={<ArrowForwardIcon />}
                              variant="outline"
                              colorScheme="blue"
                              ml={3}
                              onClick={() => {
                                if (!datasumas || !datasumas.verifid) return alert('Data tidak valid.');
                                const msgs = `Mohon izin Bapak/Ibu, izin mengirimkan disposisi dari Bapak Kalapas.\n\nSurat: ${datasumas.isisurat}.\n\nInformasi lebih detail dapat dilihat pada link berikut:\n\n${URL_WEB_FORNTEND}/#/verifikasi/suma/${datasumas.verifid}`;
                                navigator.clipboard.writeText(msgs);
                                alert(`PESAN TELAH DISALIN:\n\n${msgs}`);
                              }}> BAGIKAN</Button>
                          </Stack>
                        </Box>
                        <Box w='100%'>
                          <Text as='b'>PENGOLEH</Text>
                          <HSeparator mb='1' />
                          {datasumas.pengoleh}<br /><br />
                          <Grid templateColumns="repeat(2, 1fr)" gap={4}>
                            <Box w='100%'>
                              <Text as='b'>PARAF PENGOLEH</Text>
                              <HSeparator mb='2' />
                              <Image
                                src={datasumas.paraf}
                                bgColor='white'
                                borderRadius='16'
                                boxSize='200'
                                alt='paraf'
                                draggable='false'
                              />
                            </Box>
                            <Box w='100%'>
                              <Text as='b'>TUJUAN DISPOSISI</Text>
                              <HSeparator mb='2' />
                              <Stack spacing={1}>
                                {datasumas.disposisike && datasumas.disposisike.split(',').map((tujuan, index) => (
                                  <Checkbox key={index} isChecked={true} isReadOnly>{tujuan}</Checkbox>
                                ))}
                              </Stack>
                            </Box>
                          </Grid>
                          <Box mt={6}>
                            <Text as='b'>ISI DISPOSISI</Text>
                            <HSeparator mb='2' />
                            <Text whiteSpace='pre-line'>{datasumas.isidisposisi || '-'}</Text>
                          </Box>
                        </Box>
                      </Grid>
                    </Card>
                  </Td>
                </Tr>
              ))}
            </>
          }
        </Tbody>
      </Table>
    </Card>
  );
}
